module.exports = __webpack_public_path__ + "img/img-35.cd53e671.png";